export const CitationBuilderSx = {
    outerContainer: {
      width: '100%',
      borderRadius: { xs: '8px', sm: '12px' },
      boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
      backgroundImage: 'url(/static/images/icons/local-seo/citation-bg.png)',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      marginTop: { xs: '16px', sm: '24px' },
      marginBottom: { xs: '16px', sm: '24px' },
      minHeight: { xs: 'auto', sm: '565px' },
      paddingTop: { xs: '16px', sm: '32px' },
      paddingBottom: { xs: '16px', sm: '0px' }
    },
    innerContainer: {
      gap: { xs: '16px', sm: '32px' },
      borderRadius: { xs: '8px', sm: '12px' },
      padding: { xs: '16px', sm: '24px', md: '32px' },
      width: '100%',
      maxWidth: '828px',
      backgroundColor: 'var(--color-white)',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginX: { xs: '8px', sm: 'auto' }
    },
    titleTypography: {
      fontFamily: 'Inter',
      fontWeight: 600,
      fontSize: { xs: '18px', sm: '20px' },
      lineHeight: { xs: '26px', sm: '30px' },
      textAlign: 'center',
      color: 'var(--color-primary)',
      marginBottom: { xs: '8px', sm: '12px' },
      paddingX: { xs: '8px', sm: '0px' }
    },
    descriptionTypography: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: { xs: '14px', sm: '16px' },
      lineHeight: { xs: '20px', sm: '24px' },
      textAlign: 'center',
      color: 'var(--color-text-mid)',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '100%',
      maxWidth: '500px',
      marginBottom: { xs: '16px', sm: '32px' },
      paddingX: { xs: '8px', sm: '0px' }
    },
    imageContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      marginBottom: { xs: '16px', sm: '0px' }
    },
    image: {
      width: '100%',
      height: 'auto',
      maxWidth: '100%',
      objectFit: 'contain'
    },
    radioContainer: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      marginTop: { xs: '16px', sm: '24px' },
      width: '100%'
    },
    radioGroup: {
      display: 'flex',
      gap: { xs: '16px', sm: '24px' },
      justifyContent: 'center'
    },
    radio: {
      padding: '4px',
      color: 'var(--color-border-neutral)',
      '&.Mui-checked': {
        color: 'var(--color-primary)'
      },
      '& .MuiSvgIcon-root': {
        fontSize: 'var(--font-size-18)'
      }
    },
    radioLabel: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: { xs: '14px', sm: '16px' },
      lineHeight: { xs: '20px', sm: '24px' },
      color: 'var(--color-primary)'
    },
    formControlLabel: {
      marginLeft: 0,
      marginRight: 0,
      gap: '8px',
      '& .MuiFormControlLabel-label': {
        marginLeft: 0
      }
    },
    actionContainer: {
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: 'center',
      alignItems: 'flex-end',
      gap: { xs: '12px', sm: '12px' },
      marginTop: { xs: '16px', sm: '24px' },
      width: '100%'
    },
    dropdownContainer: {
      // width: { xs: '100%', sm: 'auto' }
      flex: 1,
    },
    businessProfileContainer: {
      // width: { xs: '100%', sm: 'auto' },
      // minWidth: { xs: '100%', sm: '300px' }
      flex: 1,
    },
    buttonContainer: {
      width: { xs: '100%', sm: 'auto' }
    },
    button: {
      gap: '8px',
      padding: { xs: '10px 24px', sm: '10px 32px' },
      borderRadius: '6px',
      minWidth: '200px'
    }
  };